export default "__VITE_ASSET__BePvGwfo__"